/** Get proportional scale relative to the rect and circle animation sizes */
export function getMouseScale(width: number, height: number): number {
  return (width > height ? width + 20 : height + 20) / 10;
}
